module.exports = __webpack_public_path__ + "img/Wp_2062.b42f5565.png";